let loading: Promise<void> | null = null;

// Prefer environment-configured URL; fallback to previous hard-coded value if missing.
const APPLE_PAY_SDK_URL = process.env.VUE_APP_APPLE_PAY_SDK_URL || 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
const APPLE_PAY_SDK_INTEGRITY = process.env.VUE_APP_APPLE_PAY_SDK_URL? process.env.VUE_APP_APPLE_PAY_SDK_INTEGRITY: undefined;

export function loadApplePaySdk(): Promise<void> {
  if (window.ApplePaySession) { return Promise.resolve(); }
  if (loading) { return loading; }

  loading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = APPLE_PAY_SDK_URL;
    s.crossOrigin = 'anonymous';
    // Only set SRI when not using the moving 1.latest alias and integrity is provided.
    if (APPLE_PAY_SDK_INTEGRITY && !/\/1\.latest\//.test(APPLE_PAY_SDK_URL)) {
      s.integrity = APPLE_PAY_SDK_INTEGRITY;
    }
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load Apple Pay JS'));
    document.head.appendChild(s);
  });

  return loading;
}

// Test-only reset hook (safe no-op in production usage)
export function resetApplePayLoaderForTest() { loading = null; }